module.exports = __webpack_public_path__ + "static/media/timeline_hand.138fa507.png";